import { z } from 'zod';
/**
 * Supported locales
 */
export const SupportedLocales = ['tr', 'en'];
export const SupportedLocaleSchema = z.enum(SupportedLocales);
/**
 * Default locale
 */
export const DefaultLocale = 'tr';
export const LocaleInfoMap = {
    tr: {
        code: 'tr',
        name: 'Turkish',
        nativeName: 'Turkce',
        flag: '\u{1F1F9}\u{1F1F7}',
        dir: 'ltr',
    },
    en: {
        code: 'en',
        name: 'English',
        nativeName: 'English',
        flag: '\u{1F1EC}\u{1F1E7}',
        dir: 'ltr',
    },
};
/**
 * Check if a locale is supported
 */
export function isSupportedLocale(locale) {
    return SupportedLocales.includes(locale);
}
/**
 * Get locale info or default
 */
export function getLocaleInfo(locale) {
    if (isSupportedLocale(locale)) {
        return LocaleInfoMap[locale];
    }
    return LocaleInfoMap[DefaultLocale];
}
//# sourceMappingURL=locales.js.map